const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
        api: "https://localhost:44348/",
  },
  production: {
      api: "https://api.cgis.asia/",
  },
};

module.exports = apiEnvironment[env];
